// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__Rx1zY","topBottomGutter":"Layout_topBottomGutter__BodzY"};